<template>
  <div id="droppalbe" class="bg2 ui-droppable">
    <div id="LayerOut">
      <div id="bg1"></div>
      <div id="page1">
        <div style="position: absolute; left: 200px; top: 33px; width: 400px">
          <input
            :value="aBill.t1"
            name="A[0].t1"
            cname="t1"
            style="
              width: 400px;
              font-size: 24px;
              font-family: 宋体;
              font-weight: bold;
              line-height: 24px;
              text-align: center;
              color: #ff0000;
            "
          />
        </div>
        <div style="position: absolute; left: 205px; top: 64px; width: 389px">
          <input
            :value="aBill.t2"
            name="A[0].t2"
            cname="t2"
            style="
              width: 389px;
              font-size: 24px;
              font-family: 宋体;
              font-weight: bold;
              line-height: 24px;
              text-align: center;
              color: #ff0000;
            "
          />
        </div>
        <div style="position: absolute; left: 591px; top: 76px; width: 157px">
          <input
            :value="aBill.t3"
            name="A[0].t3"
            cname="t3"
            style="
              width: 157px;
              font-size: 19px;
              font-family: 宋体;
              font-weight: bold;
              line-height: 24px;
              text-align: left;
              color: #ff0000;
            "
          />
        </div>
        <div style="position: absolute; left: 253px; top: 95px; width: 47px; color: #ff0000">地址：</div>
        <div style="position: absolute; left: 289px; top: 94px; width: 268px">
          <input :value="aBill.a1" name="A[0].a1" cname="a1" style="width: 268px" />
        </div>
        <div style="position: absolute; left: 253px; top: 114px; width: 47px; color: #ff0000">电话：</div>
        <div style="position: absolute; left: 289px; top: 112px; width: 120px">
          <input :value="aBill.a2" name="A[0].a2" cname="a2" style="width: 120px" />
        </div>
        <div style="position: absolute; left: 435px; top: 114px; width: 42px; color: #ff0000">邮编：</div>
        <div style="position: absolute; left: 467px; top: 112px; width: 92px">
          <input :value="aBill.a3" name="A[0].a3" cname="a3" style="width: 90px" />
        </div>
        <div style="position: absolute; left: 34px; top: 132px; width: 70px; color: #ff0000">客户名称：</div>
        <div style="position: absolute; left: 95px; top: 132px; width: 372px">
          <input :value="aBill.a4" name="A[0].a4" cname="a4" style="width: 372px" />
        </div>
        <div style="position: absolute; left: 34px; top: 148px; width: 70px; color: #ff0000">地址电话：</div>
        <div style="position: absolute; left: 95px; top: 148px; width: 372px">
          <input :value="aBill.a5" name="A[0].a5" cname="a5" style="width: 372px" />
        </div>
        <div style="position: absolute; left: 612px; top: 148px; width: 42px; color: #ff0000">日期：</div>
        <div style="position: absolute; left: 647px; top: 148px; width: 133px">
          <input :value="aBill.a6" name="A[0].a6" cname="a6" style="width: 133px" />
        </div>

        <div
          v-for="(tableCells, i) in bDataList"
          :key="i"
          style="position: absolute; top: 171px; width: 60px"
          :style="{ top: i * 23 + 171 + 'px' }"
        >
          <!--行-->
          <div
            style="position: absolute; width: 60px"
            v-for="(bDate, b_i) in tableCells.data"
            :key="b_i"
            :style="{
              left:
                b_i == 1
                  ? '96px'
                  : b_i == 2
                  ? '279px'
                  : b_i == 3
                  ? '364px'
                  : b_i == 4
                  ? '436px'
                  : b_i == 5
                  ? '526px'
                  : b_i == 6
                  ? '588px'
                  : b_i == 7
                  ? '685px'
                  : '33px',
            }"
          >
            <!--列-->
            <input
              :value="bDate"
              style="width: 60px; text-align: left"
              :class="i == 0 ? 'title-b' : ''"
              :style="{ color: i == 0 ? '#FF0000' : '' }"
            />
          </div>
        </div>

        <div style="position: absolute; left: 33px; top: 308px; width: 61px">
          <input
            :value="aBill.a15"
            name="A[0].a15"
            cname="a15"
            style="
              width: 60px;
              text-align: left;
              font-weight: normal;
              font-size: 12px;
              font-family: 宋体;
              color: #ff0000;
            "
          />
        </div>
        <div
          style="
            position: absolute;
            left: 96px;
            top: 311px;
            width: 92px;
            font-size: 12px;
            font-family: 宋体;
            color: #ff0000;
          "
        >
          人民币(大写)：
        </div>
        <div style="position: absolute; left: 178px; top: 309px; width: 336px">
          <input :value="aBill.a17" name="A[0].a17" cname="a17" style="width: 335px" />
        </div>
        <div style="position: absolute; left: 521px; top: 309px; width: 64px">
          <input
            :value="aBill.a18"
            name="A[0].a18"
            cname="a18"
            style="width: 98%; text-align: right"
            tofixed="0"
            class="isNumeric"
          />
        </div>
        <div style="position: absolute; left: 588px; top: 309px; width: 95px">
          <input
            :value="aBill.a19"
            name="A[0].a19"
            cname="a19"
            style="width: 98%; text-align: right"
            tofixed="0"
            class="isNumeric"
          />
        </div>
        <div style="position: absolute; left: 685px; top: 309px; width: 69px">
          <input :value="aBill.a20" name="A[0].a20" cname="a20" style="wwidth: 98%; text-align: left" />
        </div>
        <div style="position: absolute; left: 34px; top: 332px; width: 70px">
          <input
            :value="aBill.a21"
            name="A[0].a21"
            cname="a21"
            style="
              width: 70px;
              font-weight: normal;
              text-align: right;
              font-size: 12px;
              font-family: 宋体;
              color: #ff0000;
            "
          />
        </div>
        <div style="position: absolute; left: 177px; top: 332px; width: 70px">
          <input
            :value="aBill.a22"
            name="A[0].a22"
            cname="a22"
            style="
              width: 70px;
              font-weight: normal;
              text-align: right;
              font-size: 12px;
              font-family: 宋体;
              color: #ff0000;
            "
          />
        </div>
        <div style="position: absolute; left: 248px; top: 332px; width: 64px">
          <input :value="aBill.a26" name="A[0].a26" cname="a26" style="width: 64px" />
        </div>
        <div style="position: absolute; left: 317px; top: 332px; width: 70px">
          <input
            :value="aBill.a27"
            name="A[0].a27"
            cname="a27"
            style="
              width: 70px;
              font-weight: normal;
              text-align: right;
              font-size: 12px;
              font-family: 宋体;
              color: #ff0000;
            "
          />
        </div>
        <div style="position: absolute; left: 387px; top: 332px; width: 64px">
          <input :value="aBill.a28" name="A[0].a28" cname="a28" style="width: 64px" />
        </div>
        <div style="position: absolute; left: 463px; top: 332px; width: 70px">
          <input
            :value="aBill.a29"
            name="A[0].a29"
            cname="a29"
            style="
              width: 70px;
              font-weight: normal;
              text-align: right;
              font-size: 12px;
              font-family: 宋体;
              color: #ff0000;
            "
          />
        </div>
        <div style="position: absolute; left: 536px; top: 332px; width: 64px">
          <input :value="aBill.a30" name="A[0].a30" cname="a30" style="width: 64px" />
        </div>

        <div style="position: absolute; left: 105px; top: 332px; width: 64px">
          <input :value="aBill.a23" name="A[0].a23" cname="a23" style="width: 64px" />
        </div>
        <div style="position: absolute; left: 613px; top: 332px; width: 70px">
          <input
            :value="aBill.a24"
            name="A[0].a24"
            cname="a24"
            style="
              width: 70px;
              font-weight: normal;
              text-align: right;
              font-size: 12px;
              font-family: 宋体;
              color: #ff0000;
            "
          />
        </div>
        <div style="position: absolute; left: 685px; top: 332px; width: 69px">
          <input :value="aBill.a25" name="A[0].a25" cname="a25" style="width: 68px" />
        </div>
        <div style="position: absolute; left: 758px; top: 214px; width: 22px; color: #ff0000; height: 69px">
          会<br />计<br />联
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { environment } from '@/utils/oss.env'
export default {
  props: {
    bgDatas: { type: Array, default: () => [] },
  },
  data() {
    return {
      aBill: [],
      cachetDate: [],
      aDataList: [],
      bDataList: [],
    }
  },
  mounted() {
    this.initABData()
  },
  methods: {
    initABData() {
      let bData = {}
      const cacheList = []
      const bDataList = []
      const aDataList = []
      for (const index in this.bgDatas) {
        if (this.bgDatas[index]['a'] !== undefined) {
          bData = {}
          this.aBill = this.bgDatas[index]['a']
          bData = {}
          const t = []
          t.push(this.aBill.a7)
          t.push(this.aBill.a8)
          t.push(this.aBill.a9)
          t.push(this.aBill.a10)
          t.push(this.aBill.a11)
          t.push(this.aBill.a12)
          t.push(this.aBill.a13)
          t.push(this.aBill.a14)
          bData['data'] = t
          bDataList.push(bData)
        } else if (this.bgDatas[index]['c'] !== undefined) {
          const cl = this.bgDatas[index]['c']
          for (const jIndex in cl) {
            const c = cl[jIndex]
            bData = {}
            const t = { imgUrl: '', x: '', y: '' }
            t.imgUrl = environment.cacheUrl + c.imgUrl
            t.x = c.x + 'px'
            t.y = c.y + 'px'
            cacheList.push(t)
          }
        } else if (this.bgDatas[index]['b'] !== undefined) {
          const bl = this.bgDatas[index]['b']
          for (const jIndex in bl) {
            const b = bl[jIndex]
            bData = {}
            const t = []
            t.push(b.b1)
            t.push(b.b2)
            t.push(b.b3)
            t.push(b.b4)
            t.push(b.b5)
            t.push(b.b6)
            t.push(b.b7)
            t.push(b.b8)
            bData['data'] = t
            bDataList.push(bData)
          }
        }
      }
      this.bDataList = bDataList
      this.aDataList = aDataList
      this.cachetDate = cacheList
    },
  },
}
</script>

<style lang="less" scoped>
#LayerOut {
  position: relative;
  top: 0;
  left: 0;
  z-index: 0;
  width: 790px;
  height: 370px;
}
#page1 {
  position: relative;
  z-index: 3;
  width: 790px;
  height: 370px;
}
INPUT {
  font-family: '楷体_GB2312', '楷体';
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  background: none;
  constter-spacing: 0px;
  word-spacing: normal;
  border: 1px none #cccccc;
  overflow: hidden;
  width: 100%;
  line-height: 18px;
  color: #000048;
}
.bg2 {
  background: url(~@/assets/odiv_xsd22.jpg);
  /* background: url(xsd1.png); */
  position: relative;
  z-index: 1;
  width: 790px;
  height: 370px;
  top: 0px;
  left: 0px;
  clear: both;
}
title-b {
  text-align: center;
  font-weight: normal;
  font-size: 12px;
  font-family: 宋体;
  color: #ff0000;
}
</style>
